// extracted by mini-css-extract-plugin
module.exports = {"favorite-curated-sets":"favorite-curated-sets_favorite-curated-sets__4gp4F","favorite-curated-sets__artist":"favorite-curated-sets_favorite-curated-sets__artist__lgD9I"};